import * as Yup from 'yup'

export interface AssetHoldersSearchRequest {
  searchInput: string
}

export interface AssetHolderEmailGetGroupKeysPayload {
  reportType: string
}

export interface UpdateAssetHolderEmailAddressPayload {
  assetHolderId: number
  emailAddress: string
}

export const validateAssetHolderEmailGetGroupKeysPayload = (): any => {
  return Yup.object().shape({
    reportType: Yup.string().required()
  })
}

export interface AssetHolderEmailJobPayload {
  reportType: string
  groupKey: string
}

export const validateAssetHolderEmailJobPayload = (): any => {
  return Yup.object().shape({
    reportType: Yup.string().required(),
    groupKey: Yup.string().required(),
    assetHolderId: Yup.number()
  })
}
